import { gql } from 'graphql-tag';

export const getAssessmentSequence = gql`
    query getAssessmentSequence($assessmentSessionIds: [String!]!) {
        getAssessmentSequence(assessmentSessionIds: $assessmentSessionIds) {
            assessmentSessionId
            sequence {
                sessionId
                guid
                sequenceUrl
                nodeCollectionUrl
                activityMode
                treatment
                theme
                source
            }
            questionData {
                questionId
                questionUrl
            }
        }
    }
`;
